<template>
  <b-navbar
    ref="navbar"
    type="light"
    variant="light"
    class="navBar"
    :class="transparentNavbar && !dropdownOpen ? 'transparent' : 'text-black'"
    fixed="top"
    toggleable="md"
  >
    <b-navbar-brand :to="{ path: '/' }">
      {{ title }}
    </b-navbar-brand>

    <b-navbar-toggle
      target="navbar-toggle-collapse"
      @click="toggleDropdown"
    >
      <template v-slot:default="{ expanded }">
        <span v-if="expanded"> -</span>
        <span v-else>+</span>
      </template>
    </b-navbar-toggle>

    <b-collapse
      id="navbar-toggle-collapse"
      is-nav
      class="scrollable-menu"
    >
      <b-navbar-nav
        align="start"
      >
        <b-nav-item :to="{ path: '/Kalender' }">
          Kalender
        </b-nav-item>

        <b-nav-item :to="{ path: '/Artikel' }">
          Artikel
        </b-nav-item>
        <!-- Navbar dropdowns -->
        <NavEntry
          v-for="entry in naventrys"
          :key="entry.position"
        />
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce } from '@/helpers'
import NavEntry from '@/components/Nav/NavEntry'

export default {
  name: 'Navbar',
  components: { NavEntry },
  data () {
    return {
      scrollContainer: {},
      transparentNavbar: false,
      dropdownOpen: false
    }
  },
  computed: {
    ...mapGetters('config', [
      'getConfig',
      'configIsLoaded'
    ]),
    ...mapGetters([
      'getStoredNavbar'
    ]),
    naventrys () {
      return this.getStoredNavbar
    },
    config () {
      if (!this.configIsLoaded) {
        return []
      }
      return this.getConfig
    },
    title () {
      return this.config.TITLE
    }
  },
  watch: {
    '$route.name': {
      handler: function (name) {
        this.dropdownOpen = false
        this.transparentNavbar = false
        if (name === 'Home') {
          this.makeNavbarTransparent()
        }
      }
    }
  },
  mounted () {
    this.getNavigation(this)
  },
  methods: {
    ...mapActions([
      'getNavigation'
    ]),
    makeNavbarTransparent () {
      this.scrollContainer = document.getElementById('app')

      this.scrollContainer.addEventListener('scroll', debounce(this.manageScroll, 8), { passive: true })

      this.manageScroll()
    },
    manageScroll () {
      this.transparentNavbar = this.scrollContainer.scrollTop < 100 && this.$route.name === 'Home'
    },
    toggleDropdown () {
      this.dropdownOpen = !this.dropdownOpen
    }
  }
}
</script>

<style scoped>
.transparent {
  box-shadow: none !important;
  background: transparent !important;
}

.transparent * {
  color: white !important;
}

.navBar {
  transition: all 500ms ease;
  height: 56px;
  box-shadow: 0 2px 8px -4px rgba(0, 0, 0, 0.75);
}

#navbar-toggle-collapse {
  transition: all 500ms ease;
  background-color: transparent;
}

#navbar-toggle-collapse.collapsing, #navbar-toggle-collapse.show {
  flex: 0 0 calc(100% + 32px);
  padding: 0 8px;
  transform: translate(-16px, 8px);
  box-shadow: 0 2px 8px -4px rgba(0, 0, 0, 0.75);
}

#navbar-toggle-collapse.show {
  background-color: #f8f9fa;
  color: black !important;
}

@media only screen and (max-width: 767px) {
  .scrollable-menu {
    height: auto;
    z-index: 1031;
    max-height: calc(100vh - 56px - 51px);
    overflow-x: hidden;
  }

}
</style>
